import React from 'react';
import { Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import "swiper/css";
import "swiper/css/pagination";

const SlideShow = (props) => {
    return (
        <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={0}
            slidesPerView={1}
            pagination={{ clickable: true }}
            loop
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            speed={1000}
        >
            {props.images.map((image) => {
                return (
                    <SwiperSlide key={image.src}>
                        <img src={process.env.PUBLIC_URL + image.src} alt={image.alt} />
                    </SwiperSlide>
                )
            })}
        </Swiper>
    );
}

export default SlideShow
